<dynamic-form
  [label]="label"
  [noSubmit]="deactivateSave || deactiveForm || model.Id || currentrow"
  [saveLabel]="'ClientApp.FrontOffice.Financial.CashierSettlement.Settlement' | translate"
  [isSaved]="isSavedFinish"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  secondClass="main-page"
  [isShowModal]="false">
  <ng-container class="content">
    <div class="header" *ngIf="formGroup">
      <ssg-select
        class="gapfile"
        name="SettledPersonnelId"
        textFieldName="Title"
        [readonly]="model.Id"
        valueFieldName=""
        userClass="select-sm"
        [dataList]="userLookup"
        [group]="formGroup"
        [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.SettledPersonnelId' | translate"
        (valueChange)="changeUser()">
      </ssg-select>
      <date-picker
        class="gapfile"
        id="dpStartDate"
        name="UntilDate"
        [disabled]="model.Id"
        [group]="formGroup"
        [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.UntilDate' | translate"
        textType="date"
        [disabled]="false"></date-picker>
      <time-picker
        class="gapfile"
        name="UntilTime"
        [group]="formGroup"
        [disabled]="model.Id"
        [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.UntilTime' | translate"
        required="true"
        disabled="false">
      </time-picker>
      <div (click)="reciveInformation()" *ngIf="!model.Id && !currentrow" class="okbtn">
        {{ "ClientApp.FrontOffice.Financial.CashierSettlement.ReciveInformation" | translate }}
      </div>
    </div>

    <div class="contentbox" *ngIf="showDetail || model.Id">
      <div class="info">
        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            name="OldRemain"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.OldRemain' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Cleard)"
            name="ClearedInvoicesTotal"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.ClearedInvoicesTotal' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Pending)"
            name="PendingInvoicesTotal"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.PendingInvoicesTotal' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>
        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Cancelled)"
            name="CancelledInvoicesTotal"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.CancelledInvoicesTotal' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>
        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Customer)"
            name="CustomerClearedInvoicesTotal"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.CustomerClearedInvoicesTotal' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Personnel)"
            name="PersonnelClearedInvoicesTotal"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.PersonnelClearedInvoicesTotal' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.PaymentPersonnel)"
            name="PersonnelReceiptPaymentPaid"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.PersonnelReceiptPaymentPaid' | translate">
          </ssg-input>
          <i class="icon-minus"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.PaymentLink)"
            name="PaymentLink"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.PaymentLink' | translate">
          </ssg-input>
          <i class="icon-minus"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Debit)"
            [group]="formGroup"
            name="Debit"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Debit' | translate">
          </ssg-input>
          <i class="icon-minus"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Credit)"
            [group]="formGroup"
            name="Credit"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Credit' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>

        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            name="Tip"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Tip' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>
        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            name="TotalDeposit"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.TotalDeposit' | translate">
          </ssg-input>
          <i class="icon-add-o"></i>
        </div>
        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            name="CashierSpentCost"
            disabled="true"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.CostSpent)"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.CashierSpentCost' | translate">
          </ssg-input>
          <i class="icon-minus"></i>
        </div>

        <ssg-input
          class="cashinfo"
          [group]="formGroup"
          name="TotalPayment"
          userClass="select-sm"
          textType="currency"
          [withComma]="true"
          disabled="true"
          [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.TotalPayment' | translate">
        </ssg-input>
        <ssg-input
          class="cashinfo"
          *hasPermission="['RestaurantSale:CashierSettlemet/TotalFundBalance', 'Same']"
          [group]="formGroup"
          name="TotalAccount"
          userClass="select-sm"
          textType="currency"
          [withComma]="true"
          disabled="true"
          [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.TotalBalanceOfFunds' | translate">
        </ssg-input>
      </div>

      <div>
        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Passive)"
            name="PassiveInvoicesTotal"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.PassiveInvoicesTotal' | translate">
          </ssg-input>
        </div>
        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            [group]="formGroup"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Deleted)"
            name="DeletedInvoicesTotal"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.DeletedInvoicesTotal' | translate">
          </ssg-input>
        </div>
        <div class="pricemode">
          <ssg-input
            class="cashinfo"
            icon="icon-open_in_new-o"
            (iconClick)="openInvoicesModal(SettlementEnum.Discount)"
            [group]="formGroup"
            name="Discount"
            textType="currency"
            [withComma]="true"
            userClass="select-sm"
            disabled="true"
            [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Discount' | translate">
          </ssg-input>
        </div>
      </div>
      <div class="payment" *ngIf="currentrow">
        <div *ngIf="model.ReceiptPayments && model.ReceiptPayments.length > 0">
          <div class="recive" *ngFor="let item of model.ReceiptPayments; let i = index">
            <div class="paymentmethodbox">
              <ssg-input
                [name]="controlName('PaymentMethodTitle', i)"
                class="peymenttype"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.PaymentMethodId' | translate"
                textFieldName="Title"
                disabled="true">
              </ssg-input>
            </div>
            <ssg-input
              class="receivedmoney"
              [group]="formGroup"
              [name]="controlName('Amount', i)"
              textType="currency"
              [withComma]="true"
              disabled="true"
              [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Receivedmoney' | translate">
            </ssg-input>
          </div>
        </div>
        <div>
          <div class="pricemode">
            <ssg-input
              class="cashinfo"
              [group]="formGroup"
              name="NewRemainValue"
              userClass="select-sm"
              textType="currency"
              [withComma]="true"
              disabled="true"
              [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Remain' | translate"></ssg-input>
          </div>
          <div class="pricemode">
            <ssg-input
              [group]="formGroup"
              disabled="true"
              name="AllowedDeficit"
              textType="decimal"
              [withComma]="true"
              userClass="select-sm"
              hasClear="true"
              [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.AllowedDeficit' | translate">
            </ssg-input>
          </div>
          <div class="pricemode">
            <ssg-textarea
              type="text"
              id="Description"
              name="Description"
              [group]="formGroup"
              userClass="select-sm"
              [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Description' | translate"
              disabled="true"
              maxLength="1000"
              class="info">
            </ssg-textarea>
          </div>
        </div>
      </div>
      <div class="payment" *ngIf="!currentrow">
        <div *ngIf="model.ReceiptPayments && model.ReceiptPayments.length > 0">
          <div class="recive" *ngFor="let item of model.ReceiptPayments">
            <div class="paymentmethodbox">
              <ssg-select
                [readonly]="model.Id"
                [name]="controlName('PaymentMethodId', item.Index)"
                class="peymenttype"
                [group]="formGroup"
                [dataList]="item.PaymentMethod"
                (valueChange)="calculate()"
                [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.PaymentMethodId' | translate"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <ssg-input
              class="receivedmoney"
              hasClear="true"
              (clear)="clear(1)"
              [group]="formGroup"
              [name]="controlName('receivedmoney', item.Index)"
              textType="currency"
              [withComma]="true"
              [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Receivedmoney' | translate"
              (valueChange)="calculate()">
            </ssg-input>
            <div class="deletepeyment" *ngIf="item.State !== RowState.Modify">
              <i class="deleteicon disable icon-delete-o" (click)="removePayment(item.Index)"></i>
            </div>
          </div>
        </div>

        <div class="okbtn newrecive" (click)="addPayment()" *ngIf="!model.Id">
          {{ "ClientApp.FrontOffice.Financial.CashierSettlement.NewRecive" | translate }} +
        </div>
        <div>
          <div class="pricemode">
            <ssg-input
              class="cashinfo"
              [group]="formGroup"
              name="Remain"
              userClass="select-sm"
              textType="currency"
              [withComma]="true"
              disabled="true"
              [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Remain' | translate"></ssg-input>
          </div>
          <div class="pricemode">
            <ssg-input
              [group]="formGroup"
              (valueChange)="calculate()"
              [disabled]="model.Id"
              name="AllowedDeficit"
              textType="currency"
              [withComma]="true"
              userClass="select-sm"
              hasClear="true"
              [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.AllowedDeficit' | translate"
              (clear)="clear(1)">
            </ssg-input>
          </div>
          <div class="pricemode">
            <ssg-textarea
              type="text"
              id="Description"
              name="Description"
              [group]="formGroup"
              userClass="select-sm"
              [label]="'ClientApp.FrontOffice.Financial.CashierSettlement.Description' | translate"
              disabled="false"
              maxLength="1000"
              class="info">
            </ssg-textarea>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</dynamic-form>
